import React from "react";
import { RestrictedRoute } from "./access-route"
import asyncComponent from "../helpers/async-func";


export default [
      <RestrictedRoute
      exact
      key="payment"
      path={"/:businessName/payment"}
      component={asyncComponent(() => import("../containers/payment"))}/>,
      <RestrictedRoute
      exact
      key="payment"
      path={"/payment"}
      component={asyncComponent(() => import("../containers/payment"))}/>,
      <RestrictedRoute
      exact
      key="payment"
      path={"/payment?transId&businessId"}
      component={asyncComponent(() => import("../containers/payment"))}/>,
      <RestrictedRoute
      exact
      key="payment"
      path={"/payment?invoiceId&businessId"}
      component={asyncComponent(() => import("../containers/payment"))}/>,
      <RestrictedRoute
      exact
      key="payment"
      path={"/payment?type&pid&iat&bid&em&pn&src"}
      component={asyncComponent(() => import("../containers/payment"))}/>,
]
